import { ErrorView } from "components/ErrorView/ErrorView";
import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const UsersPage = React.lazy(() => import("modules/AdminModule/pages/UsersPage/UsersPage"));
const AwaitingApprovalPage = React.lazy(
  () => import("modules/AdminModule/pages/AwaitingApprovalPage/AwaitingApprovalPage"),
);
const ClientsPage = React.lazy(() => import("modules/AdminModule/pages/ClientsPage/ClientsPage"));
const AdminModule = React.lazy(() => import("./AdminModule"));
const ProjectGroupsPage = React.lazy(
  () => import("modules/AdminModule/pages/ProjectGroupsPage/ProjectGroupsPage"),
);

const ProjectsPage = React.lazy(() => import("modules/AdminModule/pages/ProjectsPage/ProjectsPage"));
const RegionsPage = React.lazy(() => import("modules/AdminModule/pages/RegionsPage/RegionsPage"));
const ProjectEmailSummariesPage = React.lazy(
  () => import("modules/AdminModule/pages/ProjectEmailSummariesPage/ProjectEmailSummariesPage"),
);
const AiProjectSummariesPage = React.lazy(
  () => import("modules/AdminModule/pages/AiProjectSummariesPage/AiProjectSummariesPage"),
);
const AiPromptsPage = React.lazy(() => import("modules/AdminModule/pages/AiPromptsPage/AiPromptsPage"));
const AiPromptEditPage = React.lazy(
  () => import("modules/AdminModule/pages/AiPromptEditPage/AiPromptEditPage"),
);
const AiConversationsPage = React.lazy(
  () => import("modules/AdminModule/pages/AiConversationsPage/AiConversationsPage"),
);
const AiConversationPage = React.lazy(
  () => import("modules/AdminModule/pages/AiConversationPage/AiConversationPage"),
);

const DocumentsPage = React.lazy(() => import("modules/AdminModule/pages/DocumentsPage/DocumentsPage"));
const DocumentPage = React.lazy(() => import("modules/AdminModule/pages/DocumentPage/DocumentPage"));

const AiBatchesPage = React.lazy(() => import("modules/AdminModule/pages/AiBatchesPage/AiBatchesPage"));
const AiBatchGroupsPage = React.lazy(
  () => import("modules/AdminModule/pages/AiBatchGroupsPage/AiBatchGroupsPage"),
);
const AiBatchGroupPage = React.lazy(
  () => import("modules/AdminModule/pages/AiBatchGroupPage/AiBatchGroupPage"),
);
const AiBatchPage = React.lazy(() => import("modules/AdminModule/pages/AiBatchPage/AiBatchPage"));
const AiBatchRunResultsPage = React.lazy(
  () => import("modules/AdminModule/pages/AiBatchRunResultsPage/AiBatchRunResultsPage"),
);
const PromptEvaluationsPage = React.lazy(
  () => import("modules/AdminModule/pages/PromptEvaluationsPage/PromptEvaluationsPage"),
);
const PromptEvaluationEditPage = React.lazy(
  () => import("modules/AdminModule/pages/PromptEvaluationEditPage/PromptEvaluationEditPage"),
);
const SurveysPage = React.lazy(() => import("modules/AdminModule/pages/SurveysPage/SurveysPage"));
const CreditLogsPage = React.lazy(() => import("modules/AdminModule/pages/CreditLogsPage/CreditLogsPage"));
const FFPage = React.lazy(() => import("modules/AdminModule/pages/FFPage/FFPage"));
const NotificationsAdminPage = React.lazy(
  () => import("modules/AdminModule/pages/NotificationsAdminPage/NotificationsAdminPage"),
);
const TranslationsPage = React.lazy(
  () => import("modules/AdminModule/pages/TranslationsPage/TranslationsPage"),
);
const ProjectGroupAdminEditPage = React.lazy(
  () => import("modules/AdminModule/pages/ProjectGroupAdminEditPage/ProjectGroupAdminEditPage"),
);
const AiModelDefinitionsPage = React.lazy(
  () => import("modules/AdminModule/pages/AiModelDefinitionsPage/AiModelDefinitionsPage"),
);
const WorkflowEvaluationsPage = React.lazy(
  () => import("modules/AdminModule/pages/WorkflowEvaluationsPage/WorkflowEvaluationsPage"),
);
const DemandLandscapePage = React.lazy(
  () => import("modules/AdminModule/pages/DemandLandscapePage/DemandLandscapePage"),
);
const FactsPage = React.lazy(() => import("modules/AdminModule/pages/FactsPage/FactsPage"));
const FindingsPage = React.lazy(() => import("modules/AdminModule/pages/FindingsPage/FindingsPage"));
const SyntheticPanelsAdminPage = React.lazy(
  () => import("modules/AdminModule/pages/SyntheticPanelsAdminPage/SyntheticPanelsAdminPage"),
);
const SyntheticPanelDetailPage = React.lazy(
  () => import("modules/AdminModule/pages/SyntheticPanelDetailPage/SyntheticPanelDetailPage"),
);
export const AdminModuleRoutes: RouteObject = {
  path: "/admin",
  element: <ModuleRoute El={AdminModule} moduleName="admin" inPolicy={"IdeallyAdminViewer"} />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "users",
      element: <PageRoute El={UsersPage} />,
    },
    {
      path: "approvals",
      element: <PageRoute El={AwaitingApprovalPage} />,
    },
    {
      path: "clients",
      element: <PageRoute El={ClientsPage} />,
    },
    {
      path: "projects",
      element: <PageRoute El={ProjectsPage} />,
    },
    {
      path: "regions",
      element: <PageRoute El={RegionsPage} />,
    },
    {
      path: "project-groups",
      element: <PageRoute El={ProjectGroupsPage} />,
    },
    {
      path: "project-groups/:projectGroupId/demand-landscape",
      element: <PageRoute El={DemandLandscapePage} />,
    },
    {
      path: "email-summaries",
      element: <PageRoute El={ProjectEmailSummariesPage} />,
    },
    {
      path: "documents",
      element: <PageRoute El={DocumentsPage} />,
    },
    {
      path: "documents/:documentId",
      element: <PageRoute El={DocumentsPage} />,
    },
    {
      path: "documents/:documentId/versions/:versionId",
      element: <PageRoute El={DocumentPage} />,
    },
    {
      path: "prompts/ai-model-definitions/:modelDefinitionId?",
      element: <PageRoute El={AiModelDefinitionsPage} />,
    },
    {
      path: "prompts/:promptId/workflow-evaluations",
      element: <PageRoute El={WorkflowEvaluationsPage} />,
    },
    {
      path: "prompts/:promptId?",
      element: <PageRoute El={AiPromptsPage} />,
    },
    {
      path: "prompts/batch-test",
      element: <PageRoute El={AiBatchesPage} />,
    },
    {
      path: "prompts/batch-groups",
      element: <PageRoute El={AiBatchGroupsPage} />,
    },
    {
      path: "prompts/batch-groups/:batchGroupId",
      element: <PageRoute El={AiBatchGroupPage} />,
    },
    {
      path: "prompts/batch-test/:batchId",
      element: <PageRoute El={AiBatchPage} />,
    },
    {
      path: "prompts/batch-test/:batchId/run/:runId",
      element: <PageRoute El={AiBatchRunResultsPage} />,
    },
    {
      path: "edit-prompt/:promptVersionId",
      element: <PageRoute El={AiPromptEditPage} />,
    },
    {
      path: "prompts/evaluations/:evaluationId",
      element: <PageRoute El={PromptEvaluationEditPage} />,
    },
    {
      path: "prompts/evaluations",
      element: <PageRoute El={PromptEvaluationsPage} />,
    },
    {
      path: "surveys",
      element: <PageRoute El={SurveysPage} />,
    },
    {
      path: "clients/:clientId/credits",
      element: <PageRoute El={CreditLogsPage} />,
    },
    {
      path: "features",
      element: <PageRoute El={FFPage} />,
    },
    {
      path: "project-summaries",
      element: <PageRoute El={AiProjectSummariesPage} />,
    },
    {
      path: "ai-conversations/:conversationId",
      element: <PageRoute El={AiConversationPage} />,
    },
    {
      path: "ai-conversations",
      element: <PageRoute El={AiConversationsPage} />,
    },
    {
      path: "notifications",
      element: <PageRoute El={NotificationsAdminPage} />,
    },
    {
      path: "translations",
      element: <PageRoute El={TranslationsPage} />,
    },
    {
      path: "project-groups",
      element: <PageRoute El={ProjectGroupsPage} />,
    },
    {
      path: "project-groups/:projectGroupId",
      element: <PageRoute El={ProjectGroupAdminEditPage} />,
    },
    {
      path: "projects/:projectId/facts",
      element: <PageRoute El={FactsPage} />,
    },
    {
      path: "projects/:projectId/findings",
      element: <PageRoute El={FindingsPage} />,
    },
    {
      path: "synthetic-panels",
      element: <PageRoute El={SyntheticPanelsAdminPage} />,
    },
    {
      path: "synthetic-panels/:panelId",
      element: <PageRoute El={SyntheticPanelDetailPage} />,
    },
  ],
};
